export let provDeaths = [
  {
    province: 'Eastern Cape',
    month: 'April',
    year: 2020,
    monthly_deaths: 11,
  },
  {
    province: 'Free State',
    month: 'April',
    year: 2020,
    monthly_deaths: 4,
  },
  {
    province: 'Gauteng',
    month: 'April',
    year: 2020,
    monthly_deaths: 10,
  },
  {
    province: 'KwaZulu Natal',
    month: 'April',
    year: 2020,
    monthly_deaths: 30,
  },
  {
    province: 'Limpopo',
    month: 'April',
    year: 2020,
    monthly_deaths: 2,
  },
  {
    province: 'Mpumalanga',
    month: 'April',
    year: 2020,
    monthly_deaths: 0,
  },
  {
    province: 'North West',
    month: 'April',
    year: 2020,
    monthly_deaths: 0,
  },
  {
    province: 'Northern Cape',
    month: 'April',
    year: 2020,
    monthly_deaths: 0,
  },
  {
    province: 'Unknown',
    month: 'April',
    year: 2020,
    monthly_deaths: 0,
  },
  {
    province: 'Western Cape',
    month: 'April',
    year: 2020,
    monthly_deaths: 41,
  },
  {
    province: 'Eastern Cape',
    month: 'April',
    year: 2021,
    monthly_deaths: 196,
  },
  {
    province: 'Free State',
    month: 'April',
    year: 2021,
    monthly_deaths: 207,
  },
  {
    province: 'Gauteng',
    month: 'April',
    year: 2021,
    monthly_deaths: 334,
  },
  {
    province: 'KwaZulu Natal',
    month: 'April',
    year: 2021,
    monthly_deaths: 187,
  },
  {
    province: 'Limpopo',
    month: 'April',
    year: 2021,
    monthly_deaths: 50,
  },
  {
    province: 'Mpumalanga',
    month: 'April',
    year: 2021,
    monthly_deaths: 50,
  },
  {
    province: 'North West',
    month: 'April',
    year: 2021,
    monthly_deaths: 247,
  },
  {
    province: 'Northern Cape',
    month: 'April',
    year: 2021,
    monthly_deaths: 70,
  },
  {
    province: 'Unknown',
    month: 'April',
    year: 2021,
    monthly_deaths: 0,
  },
  {
    province: 'Western Cape',
    month: 'April',
    year: 2021,
    monthly_deaths: 163,
  },
  {
    province: 'Eastern Cape',
    month: 'August',
    year: 2020,
    monthly_deaths: 1188,
  },
  {
    province: 'Free State',
    month: 'August',
    year: 2020,
    monthly_deaths: 555,
  },
  {
    province: 'Gauteng',
    month: 'August',
    year: 2020,
    monthly_deaths: 1557,
  },
  {
    province: 'KwaZulu Natal',
    month: 'August',
    year: 2020,
    monthly_deaths: 1336,
  },
  {
    province: 'Limpopo',
    month: 'August',
    year: 2020,
    monthly_deaths: 135,
  },
  {
    province: 'Mpumalanga',
    month: 'August',
    year: 2020,
    monthly_deaths: 263,
  },
  {
    province: 'North West',
    month: 'August',
    year: 2020,
    monthly_deaths: 167,
  },
  {
    province: 'Northern Cape',
    month: 'August',
    year: 2020,
    monthly_deaths: 100,
  },
  {
    province: 'Unknown',
    month: 'August',
    year: 2020,
    monthly_deaths: 0,
  },
  {
    province: 'Western Cape',
    month: 'August',
    year: 2020,
    monthly_deaths: 843,
  },
  {
    province: 'Eastern Cape',
    month: 'August',
    year: 2021,
    monthly_deaths: 1053,
  },
  {
    province: 'Free State',
    month: 'August',
    year: 2021,
    monthly_deaths: 589,
  },
  {
    province: 'Gauteng',
    month: 'August',
    year: 2021,
    monthly_deaths: 1799,
  },
  {
    province: 'KwaZulu Natal',
    month: 'August',
    year: 2021,
    monthly_deaths: 1942,
  },
  {
    province: 'Limpopo',
    month: 'August',
    year: 2021,
    monthly_deaths: 464,
  },
  {
    province: 'Mpumalanga',
    month: 'August',
    year: 2021,
    monthly_deaths: 159,
  },
  {
    province: 'North West',
    month: 'August',
    year: 2021,
    monthly_deaths: 800,
  },
  {
    province: 'Northern Cape',
    month: 'August',
    year: 2021,
    monthly_deaths: 250,
  },
  {
    province: 'Unknown',
    month: 'August',
    year: 2021,
    monthly_deaths: 0,
  },
  {
    province: 'Western Cape',
    month: 'August',
    year: 2021,
    monthly_deaths: 3192,
  },
  {
    province: 'Eastern Cape',
    month: 'December',
    year: 2020,
    monthly_deaths: 2678,
  },
  {
    province: 'Free State',
    month: 'December',
    year: 2020,
    monthly_deaths: 249,
  },
  {
    province: 'Gauteng',
    month: 'December',
    year: 2020,
    monthly_deaths: 540,
  },
  {
    province: 'KwaZulu Natal',
    month: 'December',
    year: 2020,
    monthly_deaths: 1051,
  },
  {
    province: 'Limpopo',
    month: 'December',
    year: 2020,
    monthly_deaths: 86,
  },
  {
    province: 'Mpumalanga',
    month: 'December',
    year: 2020,
    monthly_deaths: 30,
  },
  {
    province: 'North West',
    month: 'December',
    year: 2020,
    monthly_deaths: 28,
  },
  {
    province: 'Northern Cape',
    month: 'December',
    year: 2020,
    monthly_deaths: 77,
  },
  {
    province: 'Unknown',
    month: 'December',
    year: 2020,
    monthly_deaths: 0,
  },
  {
    province: 'Western Cape',
    month: 'December',
    year: 2020,
    monthly_deaths: 2195,
  },
  {
    province: 'Eastern Cape',
    month: 'December',
    year: 2021,
    monthly_deaths: 180,
  },
  {
    province: 'Free State',
    month: 'December',
    year: 2021,
    monthly_deaths: 77,
  },
  {
    province: 'Gauteng',
    month: 'December',
    year: 2021,
    monthly_deaths: 421,
  },
  {
    province: 'KwaZulu Natal',
    month: 'December',
    year: 2021,
    monthly_deaths: 273,
  },
  {
    province: 'Limpopo',
    month: 'December',
    year: 2021,
    monthly_deaths: 63,
  },
  {
    province: 'Mpumalanga',
    month: 'December',
    year: 2021,
    monthly_deaths: 20,
  },
  {
    province: 'North West',
    month: 'December',
    year: 2021,
    monthly_deaths: 50,
  },
  {
    province: 'Northern Cape',
    month: 'December',
    year: 2021,
    monthly_deaths: 72,
  },
  {
    province: 'Unknown',
    month: 'December',
    year: 2021,
    monthly_deaths: 0,
  },
  {
    province: 'Western Cape',
    month: 'December',
    year: 2021,
    monthly_deaths: 146,
  },
  {
    province: 'Eastern Cape',
    month: 'February',
    year: 2021,
    monthly_deaths: 636,
  },
  {
    province: 'Free State',
    month: 'February',
    year: 2021,
    monthly_deaths: 534,
  },
  {
    province: 'Gauteng',
    month: 'February',
    year: 2021,
    monthly_deaths: 1480,
  },
  {
    province: 'KwaZulu Natal',
    month: 'February',
    year: 2021,
    monthly_deaths: 1032,
  },
  {
    province: 'Limpopo',
    month: 'February',
    year: 2021,
    monthly_deaths: 620,
  },
  {
    province: 'Mpumalanga',
    month: 'February',
    year: 2021,
    monthly_deaths: 274,
  },
  {
    province: 'North West',
    month: 'February',
    year: 2021,
    monthly_deaths: 234,
  },
  {
    province: 'Northern Cape',
    month: 'February',
    year: 2021,
    monthly_deaths: 99,
  },
  {
    province: 'Unknown',
    month: 'February',
    year: 2021,
    monthly_deaths: 0,
  },
  {
    province: 'Western Cape',
    month: 'February',
    year: 2021,
    monthly_deaths: 920,
  },
  {
    province: 'Eastern Cape',
    month: 'February',
    year: 2022,
    monthly_deaths: 183,
  },
  {
    province: 'Free State',
    month: 'February',
    year: 2022,
    monthly_deaths: 158,
  },
  {
    province: 'Gauteng',
    month: 'February',
    year: 2022,
    monthly_deaths: 142,
  },
  {
    province: 'KwaZulu Natal',
    month: 'February',
    year: 2022,
    monthly_deaths: 184,
  },
  {
    province: 'Limpopo',
    month: 'February',
    year: 2022,
    monthly_deaths: 254,
  },
  {
    province: 'Mpumalanga',
    month: 'February',
    year: 2022,
    monthly_deaths: 2297,
  },
  {
    province: 'North West',
    month: 'February',
    year: 2022,
    monthly_deaths: 224,
  },
  {
    province: 'Northern Cape',
    month: 'February',
    year: 2022,
    monthly_deaths: 683,
  },
  {
    province: 'Unknown',
    month: 'February',
    year: 2022,
    monthly_deaths: 0,
  },
  {
    province: 'Western Cape',
    month: 'February',
    year: 2022,
    monthly_deaths: 194,
  },
  {
    province: 'Eastern Cape',
    month: 'January',
    year: 2021,
    monthly_deaths: 3338,
  },
  {
    province: 'Free State',
    month: 'January',
    year: 2021,
    monthly_deaths: 548,
  },
  {
    province: 'Gauteng',
    month: 'January',
    year: 2021,
    monthly_deaths: 2649,
  },
  {
    province: 'KwaZulu Natal',
    month: 'January',
    year: 2021,
    monthly_deaths: 4184,
  },
  {
    province: 'Limpopo',
    month: 'January',
    year: 2021,
    monthly_deaths: 677,
  },
  {
    province: 'Mpumalanga',
    month: 'January',
    year: 2021,
    monthly_deaths: 344,
  },
  {
    province: 'North West',
    month: 'January',
    year: 2021,
    monthly_deaths: 356,
  },
  {
    province: 'Northern Cape',
    month: 'January',
    year: 2021,
    monthly_deaths: 191,
  },
  {
    province: 'Unknown',
    month: 'January',
    year: 2021,
    monthly_deaths: 0,
  },
  {
    province: 'Western Cape',
    month: 'January',
    year: 2021,
    monthly_deaths: 3408,
  },
  {
    province: 'Eastern Cape',
    month: 'January',
    year: 2022,
    monthly_deaths: 919,
  },
  {
    province: 'Free State',
    month: 'January',
    year: 2022,
    monthly_deaths: 252,
  },
  {
    province: 'Gauteng',
    month: 'January',
    year: 2022,
    monthly_deaths: 322,
  },
  {
    province: 'KwaZulu Natal',
    month: 'January',
    year: 2022,
    monthly_deaths: 737,
  },
  {
    province: 'Limpopo',
    month: 'January',
    year: 2022,
    monthly_deaths: 95,
  },
  {
    province: 'Mpumalanga',
    month: 'January',
    year: 2022,
    monthly_deaths: 359,
  },
  {
    province: 'North West',
    month: 'January',
    year: 2022,
    monthly_deaths: 71,
  },
  {
    province: 'Northern Cape',
    month: 'January',
    year: 2022,
    monthly_deaths: 56,
  },
  {
    province: 'Unknown',
    month: 'January',
    year: 2022,
    monthly_deaths: 0,
  },
  {
    province: 'Western Cape',
    month: 'January',
    year: 2022,
    monthly_deaths: 1137,
  },
  {
    province: 'Eastern Cape',
    month: 'July',
    year: 2020,
    monthly_deaths: 1286,
  },
  {
    province: 'Free State',
    month: 'July',
    year: 2020,
    monthly_deaths: 145,
  },
  {
    province: 'Gauteng',
    month: 'July',
    year: 2020,
    monthly_deaths: 1819,
  },
  {
    province: 'KwaZulu Natal',
    month: 'July',
    year: 2020,
    monthly_deaths: 677,
  },
  {
    province: 'Limpopo',
    month: 'July',
    year: 2020,
    monthly_deaths: 57,
  },
  {
    province: 'Mpumalanga',
    month: 'July',
    year: 2020,
    monthly_deaths: 71,
  },
  {
    province: 'North West',
    month: 'July',
    year: 2020,
    monthly_deaths: 74,
  },
  {
    province: 'Northern Cape',
    month: 'July',
    year: 2020,
    monthly_deaths: 28,
  },
  {
    province: 'Unknown',
    month: 'July',
    year: 2020,
    monthly_deaths: 0,
  },
  {
    province: 'Western Cape',
    month: 'July',
    year: 2020,
    monthly_deaths: 1191,
  },
  {
    province: 'Eastern Cape',
    month: 'July',
    year: 2021,
    monthly_deaths: 915,
  },
  {
    province: 'Free State',
    month: 'July',
    year: 2021,
    monthly_deaths: 702,
  },
  {
    province: 'Gauteng',
    month: 'July',
    year: 2021,
    monthly_deaths: 4035,
  },
  {
    province: 'KwaZulu Natal',
    month: 'July',
    year: 2021,
    monthly_deaths: 908,
  },
  {
    province: 'Limpopo',
    month: 'July',
    year: 2021,
    monthly_deaths: 752,
  },
  {
    province: 'Mpumalanga',
    month: 'July',
    year: 2021,
    monthly_deaths: 190,
  },
  {
    province: 'North West',
    month: 'July',
    year: 2021,
    monthly_deaths: 727,
  },
  {
    province: 'Northern Cape',
    month: 'July',
    year: 2021,
    monthly_deaths: 359,
  },
  {
    province: 'Unknown',
    month: 'July',
    year: 2021,
    monthly_deaths: 0,
  },
  {
    province: 'Western Cape',
    month: 'July',
    year: 2021,
    monthly_deaths: 2778,
  },
  {
    province: 'Eastern Cape',
    month: 'June',
    year: 2020,
    monthly_deaths: 340,
  },
  {
    province: 'Free State',
    month: 'June',
    year: 2020,
    monthly_deaths: 1,
  },
  {
    province: 'Gauteng',
    month: 'June',
    year: 2020,
    monthly_deaths: 183,
  },
  {
    province: 'KwaZulu Natal',
    month: 'June',
    year: 2020,
    monthly_deaths: 74,
  },
  {
    province: 'Limpopo',
    month: 'June',
    year: 2020,
    monthly_deaths: 7,
  },
  {
    province: 'Mpumalanga',
    month: 'June',
    year: 2020,
    monthly_deaths: 7,
  },
  {
    province: 'North West',
    month: 'June',
    year: 2020,
    monthly_deaths: 6,
  },
  {
    province: 'Northern Cape',
    month: 'June',
    year: 2020,
    monthly_deaths: 0,
  },
  {
    province: 'Unknown',
    month: 'June',
    year: 2020,
    monthly_deaths: 0,
  },
  {
    province: 'Western Cape',
    month: 'June',
    year: 2020,
    monthly_deaths: 1356,
  },
  {
    province: 'Eastern Cape',
    month: 'June',
    year: 2021,
    monthly_deaths: 221,
  },
  {
    province: 'Free State',
    month: 'June',
    year: 2021,
    monthly_deaths: 685,
  },
  {
    province: 'Gauteng',
    month: 'June',
    year: 2021,
    monthly_deaths: 1663,
  },
  {
    province: 'KwaZulu Natal',
    month: 'June',
    year: 2021,
    monthly_deaths: 192,
  },
  {
    province: 'Limpopo',
    month: 'June',
    year: 2021,
    monthly_deaths: 139,
  },
  {
    province: 'Mpumalanga',
    month: 'June',
    year: 2021,
    monthly_deaths: 65,
  },
  {
    province: 'North West',
    month: 'June',
    year: 2021,
    monthly_deaths: 353,
  },
  {
    province: 'Northern Cape',
    month: 'June',
    year: 2021,
    monthly_deaths: 274,
  },
  {
    province: 'Unknown',
    month: 'June',
    year: 2021,
    monthly_deaths: 0,
  },
  {
    province: 'Western Cape',
    month: 'June',
    year: 2021,
    monthly_deaths: 549,
  },
  {
    province: 'Eastern Cape',
    month: 'March',
    year: 2020,
    monthly_deaths: 0,
  },
  {
    province: 'Free State',
    month: 'March',
    year: 2020,
    monthly_deaths: 1,
  },
  {
    province: 'Gauteng',
    month: 'March',
    year: 2020,
    monthly_deaths: 1,
  },
  {
    province: 'KwaZulu Natal',
    month: 'March',
    year: 2020,
    monthly_deaths: 2,
  },
  {
    province: 'Limpopo',
    month: 'March',
    year: 2020,
    monthly_deaths: 0,
  },
  {
    province: 'Mpumalanga',
    month: 'March',
    year: 2020,
    monthly_deaths: 0,
  },
  {
    province: 'North West',
    month: 'March',
    year: 2020,
    monthly_deaths: 0,
  },
  {
    province: 'Northern Cape',
    month: 'March',
    year: 2020,
    monthly_deaths: 0,
  },
  {
    province: 'Unknown',
    month: 'March',
    year: 2020,
    monthly_deaths: 0,
  },
  {
    province: 'Western Cape',
    month: 'March',
    year: 2020,
    monthly_deaths: 1,
  },
  {
    province: 'Eastern Cape',
    month: 'March',
    year: 2021,
    monthly_deaths: 69,
  },
  {
    province: 'Free State',
    month: 'March',
    year: 2021,
    monthly_deaths: 398,
  },
  {
    province: 'Gauteng',
    month: 'March',
    year: 2021,
    monthly_deaths: 640,
  },
  {
    province: 'KwaZulu Natal',
    month: 'March',
    year: 2021,
    monthly_deaths: 589,
  },
  {
    province: 'Limpopo',
    month: 'March',
    year: 2021,
    monthly_deaths: 327,
  },
  {
    province: 'Mpumalanga',
    month: 'March',
    year: 2021,
    monthly_deaths: 84,
  },
  {
    province: 'North West',
    month: 'March',
    year: 2021,
    monthly_deaths: 311,
  },
  {
    province: 'Northern Cape',
    month: 'March',
    year: 2021,
    monthly_deaths: 144,
  },
  {
    province: 'Unknown',
    month: 'March',
    year: 2021,
    monthly_deaths: 0,
  },
  {
    province: 'Western Cape',
    month: 'March',
    year: 2021,
    monthly_deaths: 291,
  },
  {
    province: 'Eastern Cape',
    month: 'March',
    year: 2022,
    monthly_deaths: 63,
  },
  {
    province: 'Free State',
    month: 'March',
    year: 2022,
    monthly_deaths: 44,
  },
  {
    province: 'Gauteng',
    month: 'March',
    year: 2022,
    monthly_deaths: 29,
  },
  {
    province: 'KwaZulu Natal',
    month: 'March',
    year: 2022,
    monthly_deaths: 44,
  },
  {
    province: 'Limpopo',
    month: 'March',
    year: 2022,
    monthly_deaths: 34,
  },
  {
    province: 'Mpumalanga',
    month: 'March',
    year: 2022,
    monthly_deaths: 18,
  },
  {
    province: 'North West',
    month: 'March',
    year: 2022,
    monthly_deaths: 12,
  },
  {
    province: 'Northern Cape',
    month: 'March',
    year: 2022,
    monthly_deaths: 15,
  },
  {
    province: 'Unknown',
    month: 'March',
    year: 2022,
    monthly_deaths: 0,
  },
  {
    province: 'Western Cape',
    month: 'March',
    year: 2022,
    monthly_deaths: 54,
  },
  {
    province: 'Eastern Cape',
    month: 'May',
    year: 2020,
    monthly_deaths: 71,
  },
  {
    province: 'Free State',
    month: 'May',
    year: 2020,
    monthly_deaths: 3,
  },
  {
    province: 'Gauteng',
    month: 'May',
    year: 2020,
    monthly_deaths: 22,
  },
  {
    province: 'KwaZulu Natal',
    month: 'May',
    year: 2020,
    monthly_deaths: 20,
  },
  {
    province: 'Limpopo',
    month: 'May',
    year: 2020,
    monthly_deaths: 1,
  },
  {
    province: 'Mpumalanga',
    month: 'May',
    year: 2020,
    monthly_deaths: 0,
  },
  {
    province: 'North West',
    month: 'May',
    year: 2020,
    monthly_deaths: 1,
  },
  {
    province: 'Northern Cape',
    month: 'May',
    year: 2020,
    monthly_deaths: 1,
  },
  {
    province: 'Unknown',
    month: 'May',
    year: 2020,
    monthly_deaths: 0,
  },
  {
    province: 'Western Cape',
    month: 'May',
    year: 2020,
    monthly_deaths: 461,
  },
  {
    province: 'Eastern Cape',
    month: 'May',
    year: 2021,
    monthly_deaths: 106,
  },
  {
    province: 'Free State',
    month: 'May',
    year: 2021,
    monthly_deaths: 487,
  },
  {
    province: 'Gauteng',
    month: 'May',
    year: 2021,
    monthly_deaths: 572,
  },
  {
    province: 'KwaZulu Natal',
    month: 'May',
    year: 2021,
    monthly_deaths: 124,
  },
  {
    province: 'Limpopo',
    month: 'May',
    year: 2021,
    monthly_deaths: 195,
  },
  {
    province: 'Mpumalanga',
    month: 'May',
    year: 2021,
    monthly_deaths: 56,
  },
  {
    province: 'North West',
    month: 'May',
    year: 2021,
    monthly_deaths: 208,
  },
  {
    province: 'Northern Cape',
    month: 'May',
    year: 2021,
    monthly_deaths: 218,
  },
  {
    province: 'Unknown',
    month: 'May',
    year: 2021,
    monthly_deaths: 0,
  },
  {
    province: 'Western Cape',
    month: 'May',
    year: 2021,
    monthly_deaths: 190,
  },
  {
    province: 'Eastern Cape',
    month: 'November',
    year: 2020,
    monthly_deaths: 957,
  },
  {
    province: 'Free State',
    month: 'November',
    year: 2020,
    monthly_deaths: 412,
  },
  {
    province: 'Gauteng',
    month: 'November',
    year: 2020,
    monthly_deaths: 288,
  },
  {
    province: 'KwaZulu Natal',
    month: 'November',
    year: 2020,
    monthly_deaths: 118,
  },
  {
    province: 'Limpopo',
    month: 'November',
    year: 2020,
    monthly_deaths: 48,
  },
  {
    province: 'Mpumalanga',
    month: 'November',
    year: 2020,
    monthly_deaths: 9,
  },
  {
    province: 'North West',
    month: 'November',
    year: 2020,
    monthly_deaths: 97,
  },
  {
    province: 'Northern Cape',
    month: 'November',
    year: 2020,
    monthly_deaths: 47,
  },
  {
    province: 'Unknown',
    month: 'November',
    year: 2020,
    monthly_deaths: 0,
  },
  {
    province: 'Western Cape',
    month: 'November',
    year: 2020,
    monthly_deaths: 283,
  },
  {
    province: 'Eastern Cape',
    month: 'November',
    year: 2021,
    monthly_deaths: 61,
  },
  {
    province: 'Free State',
    month: 'November',
    year: 2021,
    monthly_deaths: 93,
  },
  {
    province: 'Gauteng',
    month: 'November',
    year: 2021,
    monthly_deaths: 86,
  },
  {
    province: 'KwaZulu Natal',
    month: 'November',
    year: 2021,
    monthly_deaths: 32,
  },
  {
    province: 'Limpopo',
    month: 'November',
    year: 2021,
    monthly_deaths: 40,
  },
  {
    province: 'Mpumalanga',
    month: 'November',
    year: 2021,
    monthly_deaths: 7,
  },
  {
    province: 'North West',
    month: 'November',
    year: 2021,
    monthly_deaths: 145,
  },
  {
    province: 'Northern Cape',
    month: 'November',
    year: 2021,
    monthly_deaths: 122,
  },
  {
    province: 'Unknown',
    month: 'November',
    year: 2021,
    monthly_deaths: 0,
  },
  {
    province: 'Western Cape',
    month: 'November',
    year: 2021,
    monthly_deaths: 80,
  },
  {
    province: 'Eastern Cape',
    month: 'October',
    year: 2020,
    monthly_deaths: 557,
  },
  {
    province: 'Free State',
    month: 'October',
    year: 2020,
    monthly_deaths: 479,
  },
  {
    province: 'Gauteng',
    month: 'October',
    year: 2020,
    monthly_deaths: 477,
  },
  {
    province: 'KwaZulu Natal',
    month: 'October',
    year: 2020,
    monthly_deaths: 550,
  },
  {
    province: 'Limpopo',
    month: 'October',
    year: 2020,
    monthly_deaths: 67,
  },
  {
    province: 'Mpumalanga',
    month: 'October',
    year: 2020,
    monthly_deaths: 85,
  },
  {
    province: 'North West',
    month: 'October',
    year: 2020,
    monthly_deaths: 89,
  },
  {
    province: 'Northern Cape',
    month: 'October',
    year: 2020,
    monthly_deaths: 59,
  },
  {
    province: 'Unknown',
    month: 'October',
    year: 2020,
    monthly_deaths: 0,
  },
  {
    province: 'Western Cape',
    month: 'October',
    year: 2020,
    monthly_deaths: 179,
  },
  {
    province: 'Eastern Cape',
    month: 'October',
    year: 2021,
    monthly_deaths: 296,
  },
  {
    province: 'Free State',
    month: 'October',
    year: 2021,
    monthly_deaths: 285,
  },
  {
    province: 'Gauteng',
    month: 'October',
    year: 2021,
    monthly_deaths: 211,
  },
  {
    province: 'KwaZulu Natal',
    month: 'October',
    year: 2021,
    monthly_deaths: 170,
  },
  {
    province: 'Limpopo',
    month: 'October',
    year: 2021,
    monthly_deaths: 52,
  },
  {
    province: 'Mpumalanga',
    month: 'October',
    year: 2021,
    monthly_deaths: 38,
  },
  {
    province: 'North West',
    month: 'October',
    year: 2021,
    monthly_deaths: 65,
  },
  {
    province: 'Northern Cape',
    month: 'October',
    year: 2021,
    monthly_deaths: 82,
  },
  {
    province: 'Unknown',
    month: 'October',
    year: 2021,
    monthly_deaths: 0,
  },
  {
    province: 'Western Cape',
    month: 'October',
    year: 2021,
    monthly_deaths: 352,
  },
  {
    province: 'Eastern Cape',
    month: 'September',
    year: 2020,
    monthly_deaths: 228,
  },
  {
    province: 'Free State',
    month: 'September',
    year: 2020,
    monthly_deaths: 319,
  },
  {
    province: 'Gauteng',
    month: 'September',
    year: 2020,
    monthly_deaths: 652,
  },
  {
    province: 'KwaZulu Natal',
    month: 'September',
    year: 2020,
    monthly_deaths: 536,
  },
  {
    province: 'Limpopo',
    month: 'September',
    year: 2020,
    monthly_deaths: 189,
  },
  {
    province: 'Mpumalanga',
    month: 'September',
    year: 2020,
    monthly_deaths: 179,
  },
  {
    province: 'North West',
    month: 'September',
    year: 2020,
    monthly_deaths: 115,
  },
  {
    province: 'Northern Cape',
    month: 'September',
    year: 2020,
    monthly_deaths: 78,
  },
  {
    province: 'Unknown',
    month: 'September',
    year: 2020,
    monthly_deaths: 0,
  },
  {
    province: 'Western Cape',
    month: 'September',
    year: 2020,
    monthly_deaths: 289,
  },
  {
    province: 'Eastern Cape',
    month: 'September',
    year: 2021,
    monthly_deaths: 1001,
  },
  {
    province: 'Free State',
    month: 'September',
    year: 2021,
    monthly_deaths: 394,
  },
  {
    province: 'Gauteng',
    month: 'September',
    year: 2021,
    monthly_deaths: 669,
  },
  {
    province: 'KwaZulu Natal',
    month: 'September',
    year: 2021,
    monthly_deaths: 1033,
  },
  {
    province: 'Limpopo',
    month: 'September',
    year: 2021,
    monthly_deaths: 188,
  },
  {
    province: 'Mpumalanga',
    month: 'September',
    year: 2021,
    monthly_deaths: 100,
  },
  {
    province: 'North West',
    month: 'September',
    year: 2021,
    monthly_deaths: 331,
  },
  {
    province: 'Northern Cape',
    month: 'September',
    year: 2021,
    monthly_deaths: 188,
  },
  {
    province: 'Unknown',
    month: 'September',
    year: 2021,
    monthly_deaths: 0,
  },
  {
    province: 'Western Cape',
    month: 'September',
    year: 2021,
    monthly_deaths: 1461,
  },
]
